enum UnauthorizedPage {
  CallFinished = 'call-finished',
  CallInvitation = 'call-invitation',
  CallPreview = 'call-preview',
}

export enum UnauthorizedRouts {
  CallInvitation = `${UnauthorizedPage.CallInvitation}/:channelId`,
  CallPreview = `${UnauthorizedPage.CallPreview}/:channelId`,
  CallFinished = `${UnauthorizedPage.CallFinished}/:channelId`,
  CallInvitationLinkExpired = `${UnauthorizedPage.CallInvitation}/link-expired`,
  CallInvitationAccessDisabled = `${UnauthorizedPage.CallInvitation}/access-disabled`,
  CallInvitationLogin = `${UnauthorizedPage.CallInvitation}/login`,
}
